import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './CouponForm';

export default class CouponCrear extends Component {
    state = {
        editar: false,
        mensaje: 'Agregar Cupón',
        password: false,
    }

    componentWillMount(){
        if(this.props.match.params.id && this.props.match.params.id !== 0){
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar Cupón'
            });
        }else{
            this.props.createInitialize();
        }
    }

    verPass = () => {
        this.setState({
            password: !this.state.password
        })
    }

    render() {

        const {
            create,
            update,
        } = this.props;

        const {
            updateData,
            cargando,
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div>
                                        <div className="top-title">
                                            CUPÓN
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div>
                                    <div className="top-title">
                                        CREAR CUPÓN
                                    </div>
                                    <Form onSubmit={create}/>
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
